import { useRef } from "react";

export function useHint() {
  const alvo = useRef<HTMLSpanElement>(null) as React.RefObject<HTMLSpanElement>;

  return { alvo };
}
